/**
 * Latest Images Bulk Upload support error for the page snackbar
 * @module services/images/redux/support-error-reducer
 */
import { SHOW_BULK_UPLOAD_SUPPORT_ERROR, CLEAR_BULK_UPLOAD_SUPPORT_ERROR } from './actions'

export const initialState = null

export default function bulkUploadSupportErrorReducer (
  state = initialState,
  { type, payload } = {},
) {
  switch (type) {
    case SHOW_BULK_UPLOAD_SUPPORT_ERROR:
      return payload?.report || null
    case CLEAR_BULK_UPLOAD_SUPPORT_ERROR:
      return null
    default:
      return state
  }
}
